import _extends from "@babel/runtime/helpers/extends";
import React, { createContext, useContext } from 'react';
import { StatsigClient } from '../statsig-client';
export const StatsigContext = /*#__PURE__*/createContext({
  statsigClient: new StatsigClient() // without init it will return only falsy or default value. its required so that consumer does has to put a check for undefined
});
export function useStatsig() {
  const context = useContext(StatsigContext);
  if (context === undefined) {
    console.error('useStatsig must be used within a StatsigProvider');
  }
  return context.statsigClient;
}
export function withStatsig(Component) {
  return function StatsigComponent(props) {
    return /*#__PURE__*/React.createElement(StatsigContext.Consumer, null, _ref => {
      let {
        statsigClient
      } = _ref;
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
        statsigClient: statsigClient
      }));
    });
  };
}